import { z } from 'zod';

export const msObject = (process.env.REACT_APP_ZOD_STRATEGY === 'strict' ? z.strictObject : z.object) as typeof z.object;
